<template>
  <div style="position: relative">
    <GmapMap
      ref="mapRef"
      :center="{ lat: -2.548926, lng: 118.0148634 }"
      :zoom="5"
      map-type-id="terrain"
      style="width: 100%; min-height: 567px"
      :options="mapOptions"
    >
      <GmapCluster ref="clusterRef" :styles="clusterStyles">
        <PulseMarker
          v-for="(m, index) in markers"
          :key="index"
          :position="m"
        />
      </GmapCluster>
    </GmapMap>
    <div class="zoom-controls">
      <button class="zoom-btn" @click="zoomIn">+</button>
      <button class="zoom-btn" @click="zoomOut">−</button>
    </div>
  </div>
</template>

<script>
import GmapCluster from 'vue2-google-maps/src/components/cluster'
import PulseMarker from './PulseMarker.vue'

export default {
  name: 'DomainSummaryHeatmap',
  components: { GmapCluster, PulseMarker },
  props: ['data'],
  data() {
    return {
      mapOptions: {
        disableDefaultUI: true,
      },
    }
  },
  computed: {
    markers() {
      if (!this.data || !this.data.length) return []
      return this.data
        .filter(m => m.lat && m.lng && parseFloat(m.lat) !== 0 && parseFloat(m.lng) !== 0)
        .map(m => ({ lat: parseFloat(m.lat), lng: parseFloat(m.lng) }))
    },
    clusterStyles() {
      const size = 40
      const url = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
        `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">` +
        `<circle cx="${size / 2}" cy="${size / 2}" r="${size / 2 - 2}" fill="#eb5464" stroke="#eb5464" stroke-width="2"/>` +
        '</svg>'
      )
      return [{ url, height: size, width: size, textColor: '#ffffff', textSize: 14 }]
    },
  },
  mounted() {
    this.$refs.clusterRef.$clusterPromise.then(cluster => {
      cluster.setClusterClass('devices-monitor-cluster')
    })
  },
  methods: {
    zoomIn() {
      const map = this.$refs.mapRef.$mapObject
      map.setZoom(map.getZoom() + 1)
    },
    zoomOut() {
      const map = this.$refs.mapRef.$mapObject
      map.setZoom(map.getZoom() - 1)
    },
  },
}
</script>

<style scoped>
.zoom-controls {
  position: absolute;
  bottom: 24px;
  right: 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  z-index: 10;
}

.zoom-btn {
  width: 32px;
  height: 32px;
  background: #fff;
  border: none;
  border-radius: 2px;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  color: #666;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
}

.zoom-btn:hover {
  background: #f5f5f5;
  color: #333;
}
</style>

<style>
.devices-monitor .radar-md-green,
.devices-monitor .radar-md-yellow,
.devices-monitor .radar-md-red {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  position: relative;
}

.devices-monitor .radar-md-green::before,
.devices-monitor .radar-md-yellow::before,
.devices-monitor .radar-md-red::before {
  content: "";
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1);
  opacity: 0.3;
}

.devices-monitor .radar-md-green {
  background: #1ca967;
}

.devices-monitor .radar-md-green::before {
  background: #1ca967;
  animation: pulse-green 3s ease-out infinite;
}

.devices-monitor .radar-md-yellow {
  background: #e4aa27;
}

.devices-monitor .radar-md-yellow::before {
  background: #e4aa27;
  animation: pulse-yellow 2s ease-out infinite;
}

.devices-monitor .radar-md-red {
  background: #cc2132;
}

.devices-monitor .radar-md-red::before {
  background: #cc2132;
  animation: pulse-red 1s ease-out infinite;
}

@keyframes pulse-green {
  0% {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0;
  }
  50% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.3;
  }
  100% {
    transform: translate(-50%, -50%) scale(2.5);
    opacity: 0;
  }
}

@keyframes pulse-yellow {
  0% {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0;
  }
  50% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.3;
  }
  100% {
    transform: translate(-50%, -50%) scale(2.5);
    opacity: 0;
  }
}

@keyframes pulse-red {
  0% {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0;
  }
  50% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.3;
  }
  100% {
    transform: translate(-50%, -50%) scale(2.5);
    opacity: 0;
  }
}

.devices-monitor-cluster::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #eb5464;
  opacity: 0.3;
  transform: scale(1);
  animation: pulse-cluster 1s ease-out infinite;
}

@keyframes pulse-cluster {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  50% {
    transform: scale(1);
    opacity: 0.3;
  }
  100% {
    transform: scale(2.5);
    opacity: 0;
  }
}
</style>
